// Tracks which organisation the signed-in user is currently "acting as".
//
// A single Auth0 identity can now hold a profile row in more than one
// organisation. The client picks one to be "active" (see AuthContext.js) and
// persists that choice in localStorage. Edge-function callers (edgeFunctions.js,
// lib/ai.js) read it from here so every server call is scoped to the right org
// without every call site having to know about multi-org membership.

const STORAGE_KEY = 'tfx_active_organisation_id';

let activeOrganisationId = null;

try {
  activeOrganisationId = window.localStorage.getItem(STORAGE_KEY) || null;
} catch {
  activeOrganisationId = null;
}

export function getActiveOrganisationId() {
  return activeOrganisationId;
}

export function setActiveOrganisationId(orgId) {
  activeOrganisationId = orgId || null;
  try {
    if (activeOrganisationId) {
      window.localStorage.setItem(STORAGE_KEY, activeOrganisationId);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* localStorage unavailable — in-memory value still works for this session */
  }
}
